import { search } from '../../Api';

const centerMapToInfoWindow = (map, marker, popup) => {
  if (!popup.getProjection()) return;

  const popupPosition = popup
    .getProjection()
    .fromLatLngToDivPixel(popup.position);

  const posX = map.getDiv().offsetWidth / 2;

  //If popup is outside map then center the marker within map
  if (
    popupPosition.y < 90 ||
    posX * -1 > popupPosition.x - 150 ||
    posX < popupPosition.x + 150
  ) {
    const offsetx = 0;
    const offsety = -100;
    const scale = Math.pow(2, map.getZoom());

    const worldCoordinateCenter = map
      .getProjection()
      .fromLatLngToPoint(marker.position);
    const pixelOffset = new global.google.maps.Point(
      offsetx / scale || 0,
      offsety / scale || 0
    );

    const worldCoordinateNewCenter = new global.google.maps.Point(
      worldCoordinateCenter.x - pixelOffset.x,
      worldCoordinateCenter.y + pixelOffset.y
    );

    const newCenter = map
      .getProjection()
      .fromPointToLatLng(worldCoordinateNewCenter);
    map.setCenter(newCenter);
  }
};

const Infowindow = (location, marker, map, isCluster = false) => {
  if (typeof window === 'undefined') return null;
  if (typeof global.google === 'undefined') return null;

  //Create popup. Code from googleplex
  const Popup = function (position, content, closeBtn) {
    this.position = position;

    this.anchor = document.createElement('div');
    this.anchor.classList.add('findcare-map__map__popup');
    this.anchor.appendChild(content);

    closeBtn.addEventListener('click', () => {
      this.close();
    });

    // Optionally stop clicks, etc., from bubbling up to the map.
    this.stopEventPropagation();
  };

  // NOTE: google.maps.OverlayView is only defined once the Maps API has
  // loaded. That is why Popup is defined inside initMap().
  Popup.prototype = Object.create(global.google.maps.OverlayView.prototype);

  /** Called when the popup is added to the map. */
  Popup.prototype.onAdd = function () {
    this.getPanes().floatPane.appendChild(this.anchor);
  };

  /** Called when the popup is removed from the map. */
  Popup.prototype.onRemove = function () {
    if (this.anchor.parentElement) {
      this.anchor.parentElement.removeChild(this.anchor);
    }
  };

  /** Called when the popup needs to draw itself. */
  Popup.prototype.draw = function () {
    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
    // Hide the popup when it is far out of view.
    this.anchor.style.left = divPosition.x + 'px';
    this.anchor.style.top = divPosition.y + 'px';
  };

  /** Stops clicks/drags from bubbling up to the map. */
  Popup.prototype.stopEventPropagation = function () {
    var anchor = this.anchor;
    anchor.style.cursor = 'auto';

    [
      'click',
      'dblclick',
      'contextmenu',
      'wheel',
      'mousedown',
      'touchstart',
      'pointerdown',
    ].forEach(function (event) {
      anchor.addEventListener(event, function (e) {
        e.stopPropagation();
      });
    });
  };

  Popup.prototype.close = function () {
    this.anchor.className = 'findcare-map__map__popup';
  };
  //End Popup

  // Remove marker from map
  if (marker.infoWindow) {
    marker.infoWindow.setMap(null);
  }

  const infoBubble = document.createElement('div');
  infoBubble.className =
    'findcare-map__map__popup__office findcare-map__map__popup__content';
  const receptionCount = document.createElement('p');
  infoBubble.appendChild(receptionCount);
  const infoBubbleInner = document.createElement('div');
  infoBubbleInner.className = 'findcare-map__map__popup__content__inner';
  infoBubble.appendChild(infoBubbleInner);

  var scrollBtn = document.createElement('button');
  scrollBtn.setAttribute('type', 'button');
  scrollBtn.className = 'findcare-map__map__popup__scroll';
  scrollBtn.innerHTML = '<span class="show-for-sr">Scrolla ner</span>';
  infoBubble.appendChild(scrollBtn);

  var closeBtn = document.createElement('button');
  closeBtn.setAttribute('type', 'button');
  closeBtn.className = 'findcare-map__map__popup__close';
  closeBtn.innerHTML = '<span class="show-for-sr">Stäng</span>';
  infoBubble.appendChild(closeBtn);

  const infoBubbleOuter = document.createElement('div');

  if (isCluster) {
    infoBubbleOuter.className =
      'findcare-map__map__popup__bubble findcare-map__map__popup__bubble--is-cluster findcare-map__map__popup__bubble--is-loading';
  } else {
    infoBubbleOuter.className =
      'findcare-map__map__popup__bubble findcare-map__map__popup__bubble--is-loading';
  }

  infoBubbleOuter.appendChild(infoBubble);

  //Spinner
  const spinner = document.createElement('span');
  spinner.className = 'c-spinner';

  const bounce1 = document.createElement('span');
  bounce1.className = 'bounce1';
  spinner.appendChild(bounce1);

  const bounce2 = document.createElement('span');
  bounce2.className = 'bounce2';
  spinner.appendChild(bounce2);

  const bounce3 = document.createElement('span');
  bounce3.className = 'bounce1';
  spinner.appendChild(bounce3);

  infoBubbleOuter.appendChild(spinner);

  const popup = new Popup(
    new global.google.maps.LatLng(location.Latitude, location.Longitude),
    infoBubbleOuter,
    closeBtn,
    scrollBtn
  );

  popup.setMap(map);
  marker.infoWindow = popup;

  popup.anchor.className =
    'findcare-map__map__popup findcare-map__map__popup--is-open';
  centerMapToInfoWindow(map, marker, popup);

  search(`/api/hjv/search?id=${location.HsaId}`)
    .then((response) => response.json())
    .then((data) => {
      if (isCluster) {
        infoBubbleOuter.className =
          'findcare-map__map__popup__bubble findcare-map__map__popup__bubble--is-cluster';
        receptionCount.textContent = `Mottagningar (${data.SearchHits.length})`;
      } else {
        infoBubbleOuter.className = 'findcare-map__map__popup__bubble';
      }

      data.SearchHits.forEach((receptionData) => {
        const receptionWrapper = document.createElement('div');
        receptionWrapper.className = 'findcare-map__map__popup__wrapper';
        if (isCluster) {
          receptionWrapper.setAttribute('aria-expanded', false);
        }
        receptionWrapper.id = 'wrapper-' + receptionData.HsaId;

        if (receptionData.Heading) {
          const heading = document.createElement('h4');
          heading.className = 'findcare-map__map__popup__heading';
          const headingLink = document.createElement('a');
          headingLink.href = receptionData.Url;
          headingLink.innerText = receptionData.Heading;

          heading.appendChild(headingLink);
          receptionWrapper.appendChild(heading);

          if (isCluster) {
            const chevron = document.createElement('button');
            chevron.className = 'findcare-map__chevron';
            chevron.id = receptionData.HsaId;
            chevron.setAttribute('aria-control', receptionWrapper.id);
            chevron.addEventListener('click', () => {
              let b =
                receptionWrapper.getAttribute('aria-expanded') === 'false'
                  ? 'true'
                  : 'false';
              receptionWrapper.setAttribute('aria-expanded', b);
            });
            heading.appendChild(chevron);
          }
        }

        if (receptionData.Address) {
          const address = document.createElement('p');
          address.innerText = receptionData.Address;
          receptionWrapper.appendChild(address);
        }

        if (receptionData.PhoneNumber) {
          const phone = document.createElement('p');
          phone.className = 'findcare-map__map__popup__phone';
          const phoneLink = document.createElement('a');
          phoneLink.setAttribute(
            'href',
            `tel:${receptionData.InternationalPhoneNumber}`
          );
          phoneLink.innerText = receptionData.PhoneNumber;
          phone.appendChild(phoneLink);
          receptionWrapper.appendChild(phone);
        }

        let serviceList = null;
        const translations = window.__PRELOADED_STATE__.Content.Translations;

        const createListItem = (titleText) => {
          const elem = document.createElement('li');
          elem.className = 'findcare-search-list-item__list__item';
          const titleElem = document.createElement('p');
          titleElem.className = 'findcare-search-list-item__list__item__title';
          titleElem.innerText = titleText;
          elem.appendChild(titleElem);
          serviceList.appendChild(elem);
        };

        if (
          receptionData.HasLovContract ||
          receptionData.VideoOrChat ||
          receptionData.HasMvkServices ||
          receptionData.VaccinatesForFlu ||
          receptionData.VaccinatesForCovid19 ||
          receptionData.HasListing
        ) {
          serviceList = document.createElement('ul');
          serviceList.className =
            'findcare-search-list-item__list findcare-search-list-item__list--info-popup';
        }

        receptionData.HasLovContract &&
          createListItem(receptionData.LovContractLinkText);

        receptionData.HasMvkServices &&
          createListItem(translations.haseservices);

        receptionData.VaccinatesForCovid19 &&
          createListItem(translations.vaccinatescovid19);

        receptionData.VaccinatesForFlu &&
          createListItem(translations.vaccinatesflu);

        receptionData.VideoOrChat && createListItem(translations.videoorchat);

        receptionData.HasListing &&
          createListItem(
            receptionData.HasListingQueue
              ? translations.haslistingqueue
              : translations.haslisting
          );

        if (serviceList) receptionWrapper.appendChild(serviceList);

        //Is content higher then info popup
        if (receptionWrapper.offsetHeight >= 190) {
          infoBubble.className =
            'findcare-map__map__popup__office findcare-map__map__popup__content findcare-map__map__popup__content--overflow';
        }
        infoBubbleInner.appendChild(receptionWrapper);

        centerMapToInfoWindow(map, marker, popup);
      });
      //Scroll inside info popup
      scrollBtn.addEventListener('click', scrollDown);

      function scrollDown() {
        var height = infoBubbleInner.offsetHeight;
        infoBubbleInner.scrollBy(0, height * 0.1);
      }
    });
};

export default Infowindow;
